import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import VacationItem from "../components/vacation-item";
import Toggle from "../components/switch";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

export default function DaysHalfDisabled({
  checked,
  onChecked,
  defaultAM,
  onHandleToggle,
  dateFrom,
  dateTo,
  isMobile,
}) {
  return (
    <>
      <div
        className="check-in-out-container"
        id="days-half-disabled-from-container"
      >
        <CalendarPicker
          label={"From"}
          isStanAlone
          isDisabled
          value={dateFrom}
          id="days-half-disabled-calendar-from-component"
        />
        {checked && (
          <Toggle
            defaultAM={defaultAM}
            onHandleToggle={onHandleToggle}
            id="days-half-disabled-toggle-half-day-component"
          />
        )}
      </div>
      <div
        className="check-in-out-container"
        id="days-half-disabled-to-container"
      >
        <CalendarPicker
          label={"To"}
          isStanAlone
          isDisabled
          value={dateTo}
          id="days-half-disabled-calendar-to-component"
        />
        {checked && (
          <div
            className="empty"
            id="empty-view"
            style={{
              marginLeft: 20,
              marginRight: 20,
              width: isMobile ? 205 : 155,
            }}
          ></div>
        )}
      </div>
      <div className="toggle" id="days-half-disabled-half-day-container">
        <VacationItem
          checked={checked}
          onChecked={onChecked}
          title={"Half day"}
          icon={HourglassBottomIcon}
          color={"orange"}
          id="days-half-disabled-half-day-component"
        />
      </div>
    </>
  );
}
